"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addFiveTermBaseLoss = addFiveTermBaseLoss;
const baseLoss_js_1 = require("./baseLoss.js");
function addFiveTermBaseLoss(mfs, fiveTerm, i, options) {
    if (!options.abcdBaseLoss)
        return;
    let loss = (0, baseLoss_js_1.baseLoss)(fiveTerm);
    for (const mf of loss) {
        if (options.a) {
            mfs.push(`${mf}`.replace('$', `O-1H-1$a${i} `));
        }
        if (options.b) {
            mfs.push(`${mf}`.replace('$', `H-1$b${i} `));
        }
        if (options.c) {
            mfs.push(`${mf}`.replace('$', `PO2$c${i} `));
        }
        if (options.d) {
            mfs.push(`${mf}`.replace('$', `PO3H2$d${i} `));
        }
    }
}
//# sourceMappingURL=addFiveTermBaseLoss.js.map